/**
 * Catálogo central de eventos de telemetría. Un solo lugar de verdad
 * para los nombres: evita typos y facilita cambiar el nombre en prod.
 *
 * Convención: `<area>_<accion>` en snake_case, minúsculas.
 * Limite: 40 caracteres por nombre (restricción de GA4).
 */
export const MLV_EVENTS = Object.freeze({
  // Auth (Google sign-in)
  LOGIN_OK: 'login_ok',
  LOGIN_FAIL: 'login_fail',
  LOGIN_GOOGLE_OK: 'login_google_ok',
  LOGIN_GOOGLE_FAIL: 'login_google_fail',
  GUEST_ACCESS: 'guest_access',
  LOGOUT: 'logout',

  // Catálogo (comprador)
  CATALOGO_VER: 'catalogo_ver',
  CATALOGO_BUSCAR: 'catalogo_buscar',
  PRODUCTO_VER: 'producto_ver',
  PRODUCTO_CONTACTO_WA: 'producto_contacto_wa',
  PERFIL_VENDEDOR_VER: 'perfil_vendedor_ver',

  // Vendedor
  PUBLICAR_INICIADO: 'publicar_iniciado',
  PUBLICAR_OK: 'publicar_ok',
  PUBLICAR_FAIL: 'publicar_fail',
  PUBLICACION_ELIMINADA: 'publicacion_eliminada',
  VENTA_MARCADA: 'venta_marcada',

  // Perfil
  PERFIL_VER: 'perfil_ver',
  PERFIL_EDITAR: 'perfil_editar',
  PERFIL_CAMBIAR_FOTO: 'perfil_cambiar_foto',

  // Errores de app (auto)
  APP_ERROR: 'app_error',
});

/**
 * Campos que NUNCA deben ir en params (PII). Si aparecen, se descartan.
 */
export const MLV_PII_BLOCKLIST = Object.freeze([
  'email',
  'password',
  'telefono',
  'phone',
  'dni',
  'nombre',
  'apellido',
  'direccion',
  'token',
]);
